<template>
    <div class="topNav">
        <nav class="top">
            <a href="/dashboard" title="Dashboard" class="commerce"><img src="~@/assets/images/circle.png" width="30" /></a> <h5>Eco Cooling</h5>
        </nav>
    </div>
</template>

<script>
// @ is an alias to /src
export default {}
</script>
